import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { NextReviewPeriodRequestDialogComponent } from '../next-review-period-request-dialog/next-review-period-request-dialog.component';
import { ServiceLineGridDetail } from '@core/model';
import { ReviewPeriod } from '@shared/model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'next-review-period-request-button',
    templateUrl: './next-review-period-request-button.component.html',
    styleUrls: ['./next-review-period-request-button.component.scss'],
    standalone: false
})

export class NextReviewPeriodRequestButtonComponent implements OnChanges {
  @Input() selectedDetails: ServiceLineGridDetail[];
  @Input() reviewPeriodB: ReviewPeriod;

  @Output() nextReviewPeriodChange = new EventEmitter<{skill: string, reviewPeriod:ReviewPeriod}>();

  disabledPrecondition = false;
  skillCodesForPeriodB: string[];

  constructor(private readonly dialogService: DialogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    const { selectedDetails, reviewPeriodB } = changes;

    if (selectedDetails?.currentValue && (reviewPeriodB?.currentValue || this.reviewPeriodB)) {
      this.skillCodesForPeriodB = selectedDetails.currentValue?.length
        ? this.skillCodesForPeriodB = this.findSkillCodesForPeriodB(selectedDetails.currentValue)
        : [];
    }
  }

  createNextReviewPeriod(): void {
    this.dialogService.open(NextReviewPeriodRequestDialogComponent, {
      header: 'Select the Skill for which you want to create the request',
      width: '645px',
      data: {
        reviewPeriod: this.reviewPeriodB,
        skills: this.skillCodesForPeriodB,
      },
      closable: true,
    }).onClose.subscribe(res => {
      if (res) {
        this.nextReviewPeriodChange.emit(res);
      }
    })
  }

  findSkillCodesForPeriodB(selectedDetails: ServiceLineGridDetail[]): string[] {
    const skillCodesNotForPeriodB = selectedDetails
      .filter(details => details.reviewPeriodType === this.reviewPeriodB.reviewPeriodType)
      .map(details => details.skillCode);

    const skillCodesForPeriodB = new Set(selectedDetails
      .filter(detail => !skillCodesNotForPeriodB.includes(detail.skillCode))
      .map(detail => detail.skillCode));

    return [...skillCodesForPeriodB];
  }
}
